import React, { useState, useEffect } from "react";

const UserModal = ({ user, onClose }) => {
  const [notificationHistory, setNotificationHistory] = useState([]);
  const [userName, setUserName] = useState("");
  const Auth = localStorage.getItem("authToken");
  
    const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 20;
  useEffect(() => {
    if (user) fetchNotifications();
  }, [user]);

  if (!user) return null;

  const fetchNotifications = async () => {
    try {
      const response = await fetch(
        `https://backend.sanchalansetu.com/api/v1/notification/get/${user}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth}`,
          },
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error("Failed to fetch notifications");
      
      
      

      setNotificationHistory(result.NotificationHistory || []);
      setUserName(result.userName || user.name || "Unknown User");
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };

  const totalPages = Math.ceil(notificationHistory.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentNotification = notificationHistory.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-3xl p-6 overflow-y-auto max-h-[90vh]">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Notification Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>

        
        <div className="flex flex-col items-center mb-6">
          <h3 className="text-2xl font-bold text-gray-900">
            {userName || ""}
          </h3>
          <p className="text-gray-600">{user.email || ""}</p>
        </div>

        
        <h4 className="text-lg font-semibold text-gray-800 mb-3">
          {userName}'s All Notifications
        </h4>

        <div className="overflow-x-auto  max-h-[60vh]">
          <table className="min-w-full border border-gray-200 text-sm rounded-lg overflow-hidden">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="py-2 px-3 border-b text-left w-12">#</th>
                <th className="py-2 px-3 border-b text-left">Title</th>
                <th className="py-2 px-3 border-b text-left">Created At</th>
              </tr>
            </thead>
            <tbody className="overflow-x-auto overflow-y-auto max-h-[50vh]">
              {currentNotification.length > 0 ? (
                currentNotification.map((n, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="py-2 px-3 border-b">{index + 1}</td>
                    <td className="py-2 px-3 border-b">{n.title || "N/A"}</td>
                    <td className="py-2 px-3 border-b">
                      {formatDateTime(n.created_at)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    className="text-center py-4 text-gray-500 italic"
                  >
                    No notifications found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="flex justify-center mt-4 gap-2 items-center">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
              disabled={currentPage === 1}
            >
              Prev
            </button>

            <span className="ml-4 text-sm text-gray-600">
              Page {currentPage} / {totalPages || 1}
            </span>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>

        
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;


const formatDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  return isNaN(date.getTime()) ? value : date.toLocaleString();
};
